/**
 * The out-of-ring count in the bout HUD (the one-bout format, user 2026-10-11; rules: systems/duelRingOut.ts). Under the top
 * bar: "นอกลาน 7" in red for the player (step back in!), a quieter line for the foe; the seconds count down from 10 and start
 * afresh after every return. Over the fighters' heads: render/passes/duelRingOutMark.ts. Phones: ui/duelHudCompact.ts moves it.
 */
import { DUEL_FORMAT, duelRingOutOf, type World } from '@nine/shared';
import { h } from './dom';

const CSS = `
.duel-out{position:absolute;top:86px;left:50%;transform:translateX(-50%);display:flex;flex-direction:column;align-items:center;gap:4px;pointer-events:none}
.duel-out span{padding:4px 14px;border-radius:6px;font-weight:700;white-space:nowrap;background:rgba(22,19,15,.9);border:1px solid rgba(244,241,234,.3)}
.duel-out .me{font-size:20px;color:#ffd9cf;border-color:#d0452f;background:rgba(124,38,32,.92)}
.duel-out .me.hot{animation:duelOutPulse .5s ease infinite alternate}
.duel-out .foe{font-size:14px;color:#f4d08c}
@keyframes duelOutPulse{to{transform:scale(1.08)}}
`;

export class DuelRingOutHud {
  readonly el = h('div', { class: 'duel-out' });
  private readonly me = h('span', { class: 'me' });
  private readonly foe = h('span', { class: 'foe' });
  private key = '';

  constructor() {
    const style = document.createElement('style');
    style.textContent = CSS;
    document.head.append(style);
    this.el.append(this.me, this.foe);
    this.el.hidden = true;
  }

  /** Each frame of a bout (meId: the player's fighter); null ids hide it. */
  sync(w: World, meId: number | null, foeId: number | null, fight: boolean): void {
    const sys = duelRingOutOf(w);
    const a = fight && sys && meId !== null ? sys.infoOf(meId) : null;
    const b = fight && sys && foeId !== null ? sys.infoOf(foeId) : null;
    const meOut = !!a?.out;
    const foeOut = !!b?.out;
    const n = (x: { left: number }) => Math.max(0, Math.ceil(x.left));
    const key = `${meOut ? n(a!) : '-'}|${foeOut ? n(b!) : '-'}`;
    if (key === this.key) return;
    this.key = key;
    this.el.hidden = !meOut && !foeOut;
    this.me.hidden = !meOut;
    this.foe.hidden = !foeOut;
    if (meOut) {
      this.me.textContent = `นอกลาน ${n(a!)} · กลับเข้าลาน!`;
      this.me.classList.toggle('hot', n(a!) <= Math.ceil(DUEL_FORMAT.outLimit / 3));
    }
    if (foeOut) this.foe.textContent = `คู่ต่อสู้นอกลาน ${n(b!)}`;
  }
}
